var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pencil",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.78,
    height: 12.767,
    viewBox: "0 0 12.78 12.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M7.892,82.473.86,89.5a.28.28,0,0,0-.073.128L.008,92.762a.276.276,0,0,0,.335.336l3.128-.779a.276.276,0,0,0,.128-.073l7.032-7.032Zm0,0",
    transform: "translate(0 -80.339)",
    fill: "#2d5794"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M338.027,1.421l-.783-.783a1.417,1.417,0,0,0-1.958,0l-.959.959,2.74,2.74.959-.959a1.384,1.384,0,0,0,0-1.957Zm0,0",
    transform: "translate(-325.652 -0.247)",
    fill: "#2d5794"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.5c0ab5cc70ba0c841767372ddaa3f1ba.svg";
export { ForwardRef as ReactComponent };